import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { WhitePaperComponent } from './Components/white-paper/white-paper.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { AffiliatesComponent } from './Components/affiliates/affiliates.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { ReferralComponent } from './Components/referral/referral.component';
import { BrandComponent } from './Components/brand/brand.component';
import { TryADemoComponent } from './Components/try-ademo/try-ademo.component';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/TrinkaVsGrammarlyComponent';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
// import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
// import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
// import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
// import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "features",
    component: FeaturesComponent,
  },
  { path: "features/consistency-check", component: ConsistencyChecksComponent },
  { path: "features/personal-dictionary", component: PersonalDictionaryComponent },
  { path: "features/publication-readiness-checks", component: PublicationChecksComponent },
  { path: "features/auto-file-edit", component: AutoEditComponent },
  { path: "features/plagiarism-check", component: PlagiarismCheckerComponent },
  {
    path: "examples",
    component: ExamplesComponent,
  },
  {
    path: "pricing",
    component: PricingComponent,
  },
  {
    path: "enterprise",
    component: EnterpriseComponent,
  },
  { path: "enterprise/life-sciences-medicine-and-pharma", component: LifeSciencesMedicineAndPharmaComponent },
  { path: "enterprise/language-services-publishing-and-media", component: LanguageServicesPublishingAndMediaComponent },
  { path: "enterprise/academic-institutions", component: AcademicInstitutionsComponent },
  { path: "enterprise/k12-and-elearning", component: K12AndElearningComponent },
  { path: "enterprise/technology-platforms", component: TechnologyPlatformsComponent },
  {
    path: "wordplugin",
    component: wordpluginComponent,
  },
  {
    path: "trinkacloud",
    component: TrinkaCloudComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent
  },
  {
    path: "contactus",
    component: ContactUsComponent,
  },
  {
    path: "workwithus",
    component: WorkWithUsComponent,
  },
  {
    path: "privacypolicy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "termsofservices",
    component: TermServicesComponent,
  },
  {
    path: "grammar-checker",
    component: GcEditorComponent,
  },

  { path: "features/credits", component: CreditsComponent, },
  // {
  //   path: "try-a-demo",
  //   component: TryADemoComponent,
  // },
  {
    path: "trinka-vs-grammarly-vs-language-tool",
    component: WhitePaperComponent,
  },
  {
    path: "auto-edit",
    component: AutoEditComponent,
  },
  {
    path: "affiliates",
    component: AffiliatesComponent,
  },
  {
    path: "browser-plugin",
    component: BrowserPluginComponent,
  },
  {
    path: "publication-check",
    component: PublicationChecksComponent,
  },
  {
    path: "faqs",
    component: FAQComponent,
  },
  {
    path: "referral",
    component: ReferralComponent,
  },
  // {
  //   path: "brand-list",
  //   component: BrandComponent,
  // },
  { path: "trinka-vs-grammarly", component: TrinkaVsGrammarlyComponent },
  { path: "trinka-vs-ginger", component: TrinkaVsGingerComponent },
  { path: "trinka-vs-languagetool", component: TrinkaVsLanguagetoolComponent },
  { path: "trinka-vs-writefull", component: TrinkaVsWritefullComponent },
  { path: "enterprise/grammar-checker-api", component: APIComponent },
  { path: "punctuation-checker", component: PunctuationCheckerComponent },
  { path: "spell-checker", component: SpellCheckerComponent },
  { path: "sentence-checker", component: SentenceCheckerComponent },
  { path: "features/citation-checker", component: CitationCheckerComponent },
  { path: "citation-checker/sample-report", component: CitationSampleReportComponent },
  // { path: "features/paraphraser", component: OnlineParaphraserComponent },
  // { path: "features/latex-grammar-checker", component: LatexGrammarCheckerComponent },
  // { path: "ai-content-detector", component: AiDetectorToolComponent },
  // { path: "paraphrasing-tool", component: ParapharsingToolComponent },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
